import pick from 'lodash-es/pick'

import { FILTER_NAME_SUB_MENU } from '../../../../../constants/filter'

export function getEntityTabPostsFilterPermanentFilters({ filterValues }) {
  return pick(filterValues, [FILTER_NAME_SUB_MENU])
}
